import { Typography } from "@mui/material";
import classNames from "classnames";

const viewNames: ("Day" | "Week" | "Month")[] = ["Day", "Week", "Month"];

function ExternalViewSwitcherItem({
	item,
	isSelected,
	setCurrentViewName,
}: {
	item: "Day" | "Week" | "Month";
	isSelected: boolean;
	setCurrentViewName: (value: "Day" | "Week" | "Month") => void;
}) {
	const onClickSetCurrentViewName = () => {
		setCurrentViewName(item);
	};

	return (
		<Typography
			className={classNames("normal-text select-calendar-type-option", {
				bold: isSelected,
			})}
			onClick={onClickSetCurrentViewName}>
			{item}
		</Typography>
	);
}

export function ExternalViewSwitcher({
	currentViewName,
	setCurrentViewName,
}: {
	currentViewName: "Day" | "Week" | "Month";
	setCurrentViewName: (value: "Day" | "Week" | "Month") => void;
}) {
	return (
		<div style={{ display: "flex" }}>
			{viewNames.map((item) => (
				<ExternalViewSwitcherItem
					key={item}
					item={item}
					isSelected={currentViewName === item}
					setCurrentViewName={setCurrentViewName}
				/>
			))}
		</div>
	);
}
